import React from 'react';
import { Spinner, Container } from 'react-bootstrap';

const Loader = () => {
  return (
    <Container>
      <div className="loader-wrapper">
        <Spinner 
          animation="border" 
          role="status" 
          style={{ 
            color: 'var(--primary-color)', 
            width: '3rem', 
            height: '3rem' 
          }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    </Container>
  );
};

export default Loader;